import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, SERVICE_JOB_DETAILS, DependentTableNames, SERVICE_JOB_SPLIT_BILLING, SPLIT_BILLING } from './constants';

export enum KontrolaGarancePpTzErrorCodes {
	NeznamaChybaVSP = -1,
	NepripustnyKodZavadyVPP = 0,
	NepripustnyDruhCinnostiVPP = 1,
	Moznost2 = 2,
	NepripustnaKombinaceVPPNaPozici7Az8 = 3,
	Moznost4 = 4,
}

class Provider extends BaseApi {
	kontrolaGarancePpTz(
		vyrobekvozOzn: string | number,
		tablpozice: string | number,
		typkod: string | number,
		ppNr: string | number,
		skodanrKonPrp: string | number,
	) {
		return this
			.fetch(`/${DMS_MODULE}/${NAME}/KontrolaGarancePpTz?vyrobekvozOzn=${vyrobekvozOzn}&tablpozice=${tablpozice}
		&typkod=${typkod}&ppNr=${ppNr}&skodanrKonPrp=${skodanrKonPrp}`);
	}

	existPpProHromadnyOdpis(zakazkaId: string | number, vcetneZl: string | number | boolean) {
		return this.fetch(
			`/${DMS_MODULE}/${NAME}/ExistPpProHromadnyOdpis?zakazkaId=${zakazkaId}&vcetneZl=${vcetneZl}`,
		);
	}

	insertLabrDiscount(myZakazkaNDId: number, myDiscountPrc: number, myDiscountVal: number) {
		return this.fetch(`/${DMS_MODULE}/Zakazka/InsertLabrDiscount`, { myZakazkaNDId, myDiscountPrc, myDiscountVal });
	}

	getLaborPriceDetails(zakazkaId: number, ppNr: string, costCenterId: number | null, timeUnit:number|null) {
		return this.fetch(`/${DMS_MODULE}/Zakazka/GetLaborPriceDetails`, { zakazkaId, ppNr, costCenterId, timeUnit });
	}

	getLaborPriceDetailsWithCC(zakazkaId: number, ppNr: string, costCenterId: number | null, timeUnit:number|null) {
		return this.fetch(`/${DMS_MODULE}/Zakazka/GetLaborPriceDetails`, { zakazkaId, ppNr, costCenterId, timeUnit });
	}

	async createPracovniPozice(pracovniPozice: object) {
		return this.post(`/${DMS_MODULE}/${NAME}`, pracovniPozice);
	}

	async DeleteMultipleLabors(laborIds: number[]) {
		return this.post(`/${DMS_MODULE}/${NAME}/DeleteMultipleLabors`, laborIds);
	}

	async RevertLabors(laborIds: number[]) {
		return this.post(`/${DMS_MODULE}/${NAME}/RevertLabors`, laborIds);
	}

	sendEmailAndSmsNotificationPPID(ZaznamId:number | null) {
		return this.post(`/${DMS_MODULE}/${NAME}/SendEmailAndSmsNotificationPPID?ZaznamId=${ZaznamId}`);
	}

	async setResetAdditionalJobStatus(PPId: number | null, StatusCode: number | null) {
		return this.post(`/${DMS_MODULE}/${NAME}/SetResetAdditionalJobStatus?PPId=${PPId}&StatusCode=${StatusCode}`);
	}

	uploadLabors(fileList: any, ZakazkaId: null | number, Stav: null | number) {
		const file = new FormData();
		file.append('file', fileList.raw, fileList.name);
		return this.uploadMultipart(`/${DMS_MODULE}/${NAME}/UploadLaborsV1?zakazkaId=${ZakazkaId}&Stav=${Stav}`, file);
	}

	getSplitDetails(itemId: number | null, orderId: number | null) {
		return this.fetch(`/${DMS_MODULE}/SplitBilling/GetSplitTooltip`, { itemId, orderId });
	}

	schemaUrl(tableName: DependentTableNames) {
		return `/${this.area}/${this.controller}/${tableName}Schema`;
	}

	tableUrl(tableName: DependentTableNames) {
		return `/${this.area}/${this.controller}/${tableName}Rows`;
	}

	fetchInvoiceStatusOfServiceJobParty(serviceOrderId: number, serviceJobId: number, itemId: number, itemType: string, discountLimitPercent: number | null) {
		// eslint-disable-next-line max-len
		let url = `/${DMS_MODULE}/${SERVICE_JOB_SPLIT_BILLING}/FetchInvoiceStatusOfServiceJobParty?serviceOrderId=${serviceOrderId}&serviceJobId=${serviceJobId}&itemId=${itemId}&itemType=${itemType}`;
		if (discountLimitPercent !== null) {
			url += `&discountLimitPercent=${discountLimitPercent}`;
		}
		return this.fetch(url);
	}

	validateServiceJobWhileLaborInsertion(serviceJobId: number, serviceOrderId: number, ppNr: string, costCenterId: number | null, timeUnit: number | null, lineLevelDiscountLimitPercent: number | null) {
		return this.fetch(`/${DMS_MODULE}/${SERVICE_JOB_SPLIT_BILLING}/ValidateServiceJobWhileLaborInsertion`, { serviceJobId, serviceOrderId, ppNr, costCenterId, timeUnit, lineLevelDiscountLimitPercent });
	}

	isPartOrLabourInvoiced(orderId: number, itemId: number, itemType: string) {
		return this.fetch(`/${DMS_MODULE}/${SPLIT_BILLING}/IsPartOrLabourInvoiced`, { orderId, itemId, itemType });
	}

	isWarrantyOrGoodwillSplitExists(itemId: number, orderId:number, itemType:string) {
		return this.fetch(`/${DMS_MODULE}/${SPLIT_BILLING}/IsWarrantyOrGoodWillSplitExist`, { itemId, orderId, itemType });
	}

	isWarrantyOrGoodwillExistInServiceJobSplit(serviceOrderId:number, serviceJobId: number) {
		return this.fetch(`/${DMS_MODULE}/${SERVICE_JOB_SPLIT_BILLING}/IsWarrantyOrGoodWillSplitExistsInServiceJob`, { serviceOrderId, serviceJobId });
	}

	isAnySplitPartyInoviced(orderId:number | null, itemId:number | null, itemType:string) {
		return this.fetch(`/${DMS_MODULE}/Zakazka/IsAnySplitPartyInoviced`, { orderId, itemId, itemType });
	}

	async DeleteLabor(loCode: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/DeleteLabor`, { loCode });
	}
}

export const apiProvider = new Provider(DMS_MODULE, NAME);
